<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn fab dark small color="amber darken-2" slot="activator" @click="getData()">
                <v-icon dark>play_arrow</v-icon>
              </v-btn>
              <span>Play</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn fab dark small color="amber darken-2" slot="activator" @click="downloadExcel()">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z" />
                </svg>
              </v-btn>
              <span>Download Excel</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn fab dark small color="amber darken-1" slot="activator" @click="refreshData()">
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>
            <div class="text-center">
              <v-dialog v-model="dialogSoldCredit" max-width="1100">
                <v-card>
                  <v-card-title class="text-h5 grey font-weight-medium lighten-2">
                    Sold Credit
                  </v-card-title>
                  <v-data-table :headers="transHeader" :items="soldCreditItems" hide-actions disable-initial-sort>
                    <template slot="headers" slot-scope="props">
                      <tr>
                        <th v-for="header in props.headers" :key="header.text">
                          <span>{{ header.text }}</span>
                        </th>
                      </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.control_no
                          ? props.item.control_no
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.transaction_no
                          ? props.item.transaction_no
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.employee
                          ? props.item.employee
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.device_serial
                          ? props.item.device_serial
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.terminal_name
                          ? props.item.terminal_name
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.transaction_date
                          ? $dateFormat(
                            props.item.transaction_date,
                            "MM/DD/YYYY"
                          )
                          : "--"
                        }}
                      </td>
                    </template>
                  </v-data-table>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat icon @click="dialogSoldCredit = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogCreditRedeem" max-width="1100">
                <v-card>
                  <v-card-title class="text-h5 font-weight-medium grey lighten-2">
                    Credit Redeem
                  </v-card-title>
                  <v-data-table :headers="transHeader" :items="creditRedeemItems" hide-actions disable-initial-sort>
                    <template slot="headers" slot-scope="props">
                      <tr>
                        <th v-for="header in props.headers" :key="header.text">
                          <span>{{ header.text }}</span>
                        </th>
                      </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.control_no
                          ? props.item.control_no
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.transaction_no
                          ? props.item.transaction_no
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.employee
                          ? props.item.employee
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.device_serial
                          ? props.item.device_serial
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.terminal_name
                          ? props.item.terminal_name
                          : "--"
                        }}
                      </td>
                      <td class="text-xs-center">
                        {{
                          props.item && props.item.transaction_date
                          ? $dateFormat(
                            props.item.transaction_date,
                            "MM/DD/YYYY"
                          )
                          : "--"
                        }}
                      </td>
                    </template>
                  </v-data-table>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat icon @click="dialogCreditRedeem = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-container grid-list-lg fluid style="padding: 20px 0px 0px 25px" class="mt-3">
            <v-layout>
              <v-flex md2 style="padding: 0 5px;">
                <v-menu ref="dateFromMenu" v-model="dateFromMenu" lazy transition="scale-transition" offset-y full-width
                  min-width="290px">
                  <v-text-field slot="activator" v-model="dateFrom" label="Date From" prepend-inner-icon="event" outline
                    readonly></v-text-field>

                  <v-date-picker ref="picker" v-model="dateFrom" :max="dateTo" min="1950-01-01"
                    @input="dateFromMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex md2 style="padding: 0 5px;">
                <v-menu ref="dateToMenu" v-model="dateToMenu" lazy transition="scale-transition" offset-y full-width
                  min-width="290px">
                  <v-text-field slot="activator" v-model="dateTo" label="Date To" prepend-inner-icon="event" outline
                    readonly></v-text-field>

                  <v-date-picker ref="picker" v-model="dateTo" :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom" @input="dateToMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md2 style="margin-left: 15px;  margin-top: 5px; padding: 0 5px;">
                <template>
                  <v-select v-model="filterStatus" :items="filterStats" label="Filter By Status" clearable
                    solo></v-select>
                </template>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-data-table :headers="headers" :items="items" :rows-per-page-items="[10, 20, 30, 40, 100]">
            <template slot="headers" slot-scope="props">
              <tr>
                <th v-for="header in props.headers" :key="header.text" :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]">
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <!-- {{ props.index + queryParams.offset + 1 }} -->
                {{ props.item.index_no }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{ props.item.card_number }}
              </td>
              <td class="text-xs-center no-wrap">
                {{
                  props.item.sold_date && props.item.sold_time
                  ? $dateFormat(props.item.sold_date, "YYYY-MM-DD") +
                  " " +
                  props.item.sold_time.substr(0, 5)
                  : "--"
                }}
              </td>
              <td class="text-xs-center">
                <v-tooltip top>
                  <v-btn fab dark small color="blue lighten-3" slot="activator"
                    @click="getSoldCredit(props.item.card_number)">
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path fill="currentColor" d="M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" />
                    </svg>
                  </v-btn>
                  <span>Sold Details</span>
                </v-tooltip>
              </td>
              <td class="text-xs-center text-uppercase">
                {{
                  props.item.register_date && props.item.register_time
                  ? $dateFormat(props.item.register_date, "YYYY-MM-DD") +
                  " " +
                  props.item.register_time.substr(0, 5)
                  : "--"
                }}
              </td>

              <td class="text-xs-center text-uppercase">
                {{ props.item.credit_code ? props.item.credit_code : "--" }}
              </td>
              <td class="text-xs-center">
                {{ props.item.credit_date ? props.item.credit_date : "--" }}
              </td>
              <td class="text-xs-center no-wrap">
                {{
                  props.item.code_expiration
                  ? daysDiff(
                    $dateFormat(props.item.code_expiration, "YYYY-MM-DD")
                  )
                  : "--"
                }}
              </td>
              <td class="text-xs-center no-wrap">
                {{
                  props.item.redeem_date && props.item.redeem_time
                  ? $dateFormat(props.item.redeem_date, "YYYY-MM-DD") +
                  " " +
                  props.item.redeem_time.substr(0, 5)
                  : "--"
                }}
              </td>
              <td class="text-xs-center no-wrap">
                {{ props.item.redeem_date ? "Redeemed" : props.item.status == 0 ? "" : "Cancelled Code" }}
                <v-tooltip top>
                  <v-btn v-if="props.item.status == 0 && props.item.redeem_date == null" fab dark small
                    color="red lighten-3" slot="activator" @click="showConfirmationDialog(props.item.card_number)">
                    <v-icon></v-icon>
                    <svg style="width:48px;height:48px" viewBox="0 0 48 48">
                      <path fill="#f44336"
                        d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" />
                      <path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" />
                      <path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" />
                    </svg>
                    <v-dialog v-model="showDialog" max-width="500" persistent>
                      <v-card>
                        <v-card-title class="v-card__title title">Cancel</v-card-title>
                        <v-card-text>
                          Are you sure you want to cancel this code?
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <div class="mr-5">
                                <v-btn fab dark small class="v-btn v-btn--flat theme--light" slot="activator"
                                  @click="handleCancellation" v-on="on">
                                  <svg height="24px" viewBox="0 0 24 24" width="35px" fill="#00974B">
                                    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                                  </svg>
                                </v-btn>
                              </div>
                            </template>
                            <span>Yes</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <div class="mr-4">
                                <v-btn fab dark small class="v-btn v-btn--flat theme--light" slot="activator"
                                  @click="showDialog = false" v-on="on">
                                  <svg viewBox="0 0 24 24" width="25px" fill="#FC0000">
                                    <path
                                      d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                                  </svg>
                                </v-btn>
                              </div>
                            </template>
                            <span>No</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-btn>
                  <span>Cancel Code</span>
                </v-tooltip>
              </td>
              <td class="text-xs-center no-wrap">
                {{ props.item.status !== 0 ? props.item.cancelled_by : '' }}
              </td>

              <td class="text-xs-center no-wrap">
                <v-tooltip top>
                  <v-btn fab dark small color="blue lighten-3" slot="activator"
                    @click="getCreditRedeem(props.item.card_number)">
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d="M20,14H4V8H9.08L7,10.83L8.62,12L11,8.76L12,7.4L13,8.76L15.38,12L17,10.83L14.92,8H20M20,19H4V17H20M9,4A1,1 0 0,1 10,5A1,1 0 0,1 9,6A1,1 0 0,1 8,5A1,1 0 0,1 9,4M15,4A1,1 0 0,1 16,5A1,1 0 0,1 15,6A1,1 0 0,1 14,5A1,1 0 0,1 15,4M20,6H17.82C17.93,5.69 18,5.35 18,5A3,3 0 0,0 15,2C13.95,2 13.04,2.54 12.5,3.35L12,4L11.5,3.34C10.96,2.54 10.05,2 9,2A3,3 0 0,0 6,5C6,5.35 6.07,5.69 6.18,6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z" />
                    </svg>
                  </v-btn>
                  <span>Redeem Details</span>
                </v-tooltip>
              </td>
              <td class="text-xs-center text-uppercase">
                {{ props.item.credit_amount ? props.item.credit_amount : "--" }}
              </td>
              <td class="text-no-wrap text-xs-center">
                <v-tooltip top>
                  <v-btn fab dark small color="blue lighten-3" slot="activator"
                    @click="resendCode(props.item.card_number)" :disabled="props.item.status == 0
                      ? props.item.redeem_date
                        ? true
                        : false
                      : true
                      ">
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2M18 11H13L14.81 9.19A3.94 3.94 0 0 0 12 8A4 4 0 1 0 15.86 13H17.91A6 6 0 1 1 12 6A5.91 5.91 0 0 1 16.22 7.78L18 6Z" />
                    </svg>
                  </v-btn>
                  <span>Resend Code</span>
                </v-tooltip>
                |
                <v-tooltip top>
                  <v-btn fab dark small color="blue lighten-3" slot="activator"
                    @click="regenerateCode(props.item.card_number)" :disabled="props.item.redeem_date ? true : false">
                    <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d="M6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.03C18.17 12 18.33 12 18.5 12C19 12 19.5 12.07 20 12.18V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.17 21 12.33 21 12.5 21C12.24 20.37 12.09 19.7 12.03 19L12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.17 16 12.34 16 12.5 16C12.85 15.18 13.34 14.46 13.95 13.86C13.32 13.95 12.67 14 12 14C9.58 14 7.3 13.4 6 12.45M12 5C15.87 5 18 6.5 18 7S15.87 9 12 9 6 7.5 6 7 8.13 5 12 5M18 18.5L19.77 16.73C19.32 16.28 18.69 16 18 16C16.62 16 15.5 17.12 15.5 18.5S16.62 21 18 21C18.82 21 19.54 20.61 20 20H21.71C21.12 21.47 19.68 22.5 18 22.5C15.79 22.5 14 20.71 14 18.5S15.79 14.5 18 14.5C19.11 14.5 20.11 14.95 20.83 15.67L22 14.5V18.5H18Z" />
                    </svg>
                  </v-btn>
                  <span>Regenerate Code</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/CreditDetailsContainer.vue";
import XLSX from "xlsx";
var now = new Date();
var week = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 15);
import moment from "moment";

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      showDialog: false,
      cardToCancel: null,
      dialogue: false,
      dialogSoldCredit: false,
      dialogCreditRedeem: false,
      companies: [],
      subcompanies: [],
      assignCompany: "",
      assignSubCompany: "",

      cancelDialog: false,
      cancelType: "",
      remarksDialog: false,

      confirmLoading: false,
      dialogLoading: false,
      items: [],
      title: "Sold Credit",
      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Card #",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Sold Date",
          align: "center",
          value: "sold date",
          sortable: false,
        },
        {
          text: "Sold Details",
          align: "center",
          value: "sold details",
          sortable: false,
        },
        {
          text: "Register Date",
          align: "center",
          value: "register date",
          sortable: false,
        },
        {
          text: "Credit Code",
          align: "center",
          value: "credit code",
          sortable: false,
        },
        {
          text: "Code Generated",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Aging (Days)",
          align: "center",
          value: "status",
          sortable: false,
        },
        {
          text: "Redeem Date",
          align: "center",
          value: "redeem",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Cancelled By",
          align: "center",
          value: "cancelled_by",
          sortable: false,
        },
        {
          text: "Redeem Details",
          align: "center",
          value: "redeem details",
          sortable: false,
        },
        {
          text: "Credit Amount",
          align: "center",
          value: "credit_amount",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          value: "action",
          sortable: true,
        },
      ],
      transHeader: [
        {
          text: "Control Number",
          align: "center",
          value: "control number",
          sortable: false,
        },
        {
          text: "Transaction Number",
          align: "center",
          value: "transaction number",
          sortable: false,
        },
        {
          text: "Employee Name",
          align: "center",
          value: "employee name",
          sortable: false,
        },
        {
          text: "Device Serial",
          align: "center",
          value: "device serial",
          sortable: false,
        },
        {
          text: "Terminal Name",
          align: "center",
          value: "terminal namet",
          sortable: false,
        },
        {
          text: "Transaction Date",
          align: "center",
          value: "transaction date",
          sortable: false,
        },
      ],
      downloadExcelHeader: [
        {
          text: "Card #",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Sold Date",
          align: "center",
          value: "sold date",
          sortable: false,
        },
        {
          text: "Sold Time",
          align: "center",
          value: "sold time",
          sortable: false,
        },
        {
          text: "Register Date",
          align: "center",
          value: "register date",
          sortable: false,
        },
        {
          text: "Register Time",
          align: "center",
          value: "register time",
          sortable: false,
        },
        {
          text: "Credit Code",
          align: "center",
          value: "credit code",
          sortable: false,
        },
        {
          text: "Code Generated",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Code Generated Time",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Aging (Days)",
          align: "center",
          value: "status",
          sortable: false,
        },
        {
          text: "Redeem Date",
          align: "center",
          value: "redeem",
          sortable: false,
        },
        {
          text: "Redeem Time",
          align: "center",
          value: "redeem",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          value: "status",
          sortable: false,
        },
        {
          text: "Cancelled By",
          align: "center",
          value: "cancelled_by",
          sortable: false,
        },
        {
          text: "Credit Amount",
          align: "center",
          value: "credit_amount",
          sortable: false,
        },
      ],
      data: {},
      valid: true,
      viewData: {},
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        limitValue: (value) => {
          if (value > 5000) {
            return "Maximum of 5000 only";
          } else {
            return true;
          }
        },
      },
      queryParams: {
        search: null,
        limit: 10,
        offset: 0,
      },
      totalItems: 0,
      dialogLoading: false,
      dialogType: "",
      dialogTitle: "",
      dialogStatus: false,
      openConfirmDialog: false,
      confirmLoading: false,
      valid: true,
      dateFromMenu: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateToMenu: false,
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      uploadLoading: false,
      valid: true,
      creditRedeemItems: [],
      soldCreditItems: [],
      filterStatus: "",
      filterStats: [
        {
          text: "PENDING",
          value: 0,
        },
        {
          text: "REDEEMED",
          value: 1,
        },
        {
          text: "CANCELLED CODE",
          value: 2,
        },
      ],
    };
  },
  created: async function () {
    // await this.getData();
    // console.log(this.$store.state.employee);
  },
  computed: {
    pageLimit: {
      get() {
        return 1;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
    computedData() {
      return {
        user_id: this.$store.state.employee.id,
      };
    },
  },
  watch: {
    filterStatus: async function () {
      if (
        this.filterStatus !== null &&
        this.filterStatus !== undefined &&
        this.filterStatus !== "".type
      ) {
        this.queryParams.offset = 0;
        this.queryParams.status = this.filterStatus;
        // this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.status = null;
        // this.getData();
      }
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      // this.getData();
    },
    async getData() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;

      try {
        // Query Data
        let response = (await Services.getSoldCredit(this.queryParams)).data;
        // console.log(response.data);
        // Assign the reponse data to items to be display on table
        this.items = response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    openFilterExpansion() {
      this.openFilter = !this.openFilter;
    },
    daysDiff(expiration_date) {
      const days = moment(expiration_date).diff(now, "days");
      return days <= 0 ? "Lapse" : days;
    },
    async getSoldCredit(card_no) {
      this.$store.dispatch("startLoading");
      this.dialogSoldCredit = true;

      const params = {
        card_no,
      };

      try {
        const response = (await Services.getSoldCreditDetails(params)).data;

        this.soldCreditItems = new Array(response.data);
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
        this.$store.dispatch("endLoading");
      }

      setTimeout(() => {
        this.dialogLoading = false;
        this.$store.dispatch("endLoading");
      }, 600);
    },

    async showConfirmationDialog(card_no) {
      this.cardToCancel = card_no;
      this.showDialog = true;
    },

    async handleCancellation() {
      const cancelBy = this.$store.state.employee.first_name + " " + this.$store.state.employee.last_name
      this.showDialog = false; // Hide the confirmation dialog

      // Call the cancellation API with the selected card number
      if (this.cardToCancel) {
        this.$store.dispatch("startLoading");
        const body = {
          card_number: this.cardToCancel,
          cancel_by: cancelBy
        };

        try {
          const response = await Services.cancelledCode(body);

          if (response.status === 201 || response.status === 200) {
            this.$infoBar({
              type: "success",
              text: "Code Cancelled!",
            });
            await this.getData();
          } else {
            this.$infoBar({
              type: "error",
              text: "Server Error!",
            });
          }
        } catch (error) {
          if (!error.response) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$infoBar({
              type: "error",
              text: `${this.$capitalizeFirstLetter(error.response.data.message)}`,
            });
          }
        } finally {
          this.$store.dispatch("endLoading");
        }
      }
    },

    async getCreditRedeem(card_no) {
      this.$store.dispatch("startLoading");
      this.dialogCreditRedeem = true;

      const params = {
        card_no,
      };

      try {
        const response = (await Services.getCreditRedeemDetails(params)).data;

        this.creditRedeemItems = new Array(response.data);
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
        this.$store.dispatch("endLoading");
      }

      setTimeout(() => {
        this.dialogLoading = false;
        this.$store.dispatch("endLoading");
      }, 600);
    },
    async resendCode(card_no) {
      this.$store.dispatch("startLoading");
      const body = {
        card_number: card_no,
      };

      try {
        const response = await Services.resendCode(body);

        if (response.status === 201 || response.status === 200) {
          this.$infoBar({
            type: "success",
            text: "Code Sent!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: `${this.$capitalizeFirstLetter(error.response.data.message)}`,
          });
        }
        this.$store.dispatch("endLoading");
      }
      this.$store.dispatch("endLoading");
    },
    async regenerateCode(card_no) {
      this.$store.dispatch("startLoading");
      const body = {
        card_number: card_no,
      };

      try {
        const response = await Services.regenerateCode(body);

        if (response.status === 201 || response.status === 200) {
          this.$infoBar({
            type: "success",
            text: "Code Regenerated!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: `${this.$capitalizeFirstLetter(error.response.data.message)}`,
          });
        }
        this.$store.dispatch("endLoading");
      }
      this.$store.dispatch("endLoading");
    },
    async openAddDialog(type) {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      this.dialogTitle = type;

      if (type === "Replenish") {
        await this.setCompanies();
      }

      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");
      this.nextWeek = this.$dateFormat(week, "YYYY-MM-DD");

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.dialogTitle = this.title;

      this.viewData = await this.setData(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async saveCancelDialog() {
      this.confirmLoading = true;
      console.log(this.$refs.remark.remarks);
      try {
        const body = {
          id: this.viewData.id,
          remarks: this.$refs.remark.remarks,
        };
        const response = await Services.cancelCredit(body);
        if (response.status === 200 || response.status === 201) {
          this.closeCancelDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Credit has been canceled!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.closeCancelDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      this.confirmLoading = false;
    },
    async openCancelDialog(data) {
      // this.cancelDialog = true;
      this.remarksDialog = true;
      this.viewData.id = data.id;
    },
    async closeCancelDialog() {
      // this.cancelDialog = false;
      this.remarksDialog = false;
    },
    async setData(items) { },
    closeDialog() {
      if (this.dialogLoading === false && this.dialogTitle === "Dispute") {
        this.$refs.form.reset();
      }

      if (this.dialogLoading === false && this.dialogTitle === "Replenish") {
        this.$refs.formCompany.reset();
        this.$refs.formSubCompany.reset();
        this.$refs.formReplenish.reset();
      }

      if (this.dialogLoading === false && this.dialogTitle === "Promo") {
        this.$refs.formPromo.reset();
      }

      this.e1 = 0;
      this.viewData = {};

      this.closeConfirmDialog();
      this.dialogTitle = "";
      this.dialogType = "";
      this.dialogStatus = false;
      this.promoDialog = false;
      this.uploadItems = [];
    },
    saveDialog() {
      if (this.dialogTitle === "Dispute") {
        if (this.$refs.form.validate()) {
          this.openConfirmDialog = true;
        }
      }
      if (this.dialogTitle === "Replenish") {
        if (this.$refs.formReplenish.validate()) {
          this.openConfirmDialog = true;
        }
      }
      if (this.dialogTitle === "Promo") {
        if (this.$refs.formPromo.validate()) {
          this.openConfirmDialog = true;
        }
      }
    },
    async setCompanies() {
      this.companies = [];
      const items = (await Services.getCompanies({})).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.companies.push(data);
      }
    },
    async setSubCompanies() {
      this.subcompanies = [];
      const items = (
        await Services.getSubCompanies({
          company_id: this.assignCompany.value,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.subcompanies.push(data);
      }
    },

    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    refreshData() {
      this.items = [];

      this.queryParams.date_from = this.$dateFormat(now, "YYYY-MM-DD");
      this.queryParams.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.queryParams.limit = 10;
      this.queryParams.offset = 0;
      this.queryParams.status = null;

      this.dateFrom = this.$dateFormat(now, "YYYY-MM-DD");
      this.dateTo = this.$dateFormat(now, "YYYY-MM-DD");
      this.filterStatus = "";
      this.totalItems = 0;

      this.getData();
    },
    async downloadExcel() {
      if (this.items.length == 0) return;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.downloadExcelHeader.length; i++) {
        header.push(this.downloadExcelHeader[i].text);
      }

      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];
        theItem.push(
          this.items[e].card_number ? this.items[e].card_number : "--"
        );
        theItem.push(this.items[e].sold_date ? this.items[e].sold_date : "--");
        theItem.push(
          this.items[e].sold_time ? this.items[e].sold_time.substr(0, 5) : "--"
        );
        theItem.push(
          this.items[e].register_date ? this.items[e].register_date : "--"
        );
        theItem.push(
          this.items[e].register_time
            ? this.items[e].register_time.substr(0, 5)
            : "--"
        );
        theItem.push(
          this.items[e].credit_code ? this.items[e].credit_code : "--"
        );
        theItem.push(
          this.items[e].credit_date ? this.items[e].credit_date : "--"
        );
        theItem.push(
          this.items[e].credit_time
            ? this.items[e].credit_time.substr(0, 5)
            : this.items[e].credit_time
              ? this.items[e].credit_time
              : "--"
        );
        theItem.push(
          this.items[e].code_expiration !== null
            ? this.daysDiff(
              this.$dateFormat(this.items[e].code_expiration, "YYYY-MM-DD")
            )
            : "--"
        );
        theItem.push(
          this.items[e].redeem_date ? this.items[e].redeem_date : "--"
        );
        theItem.push(
          this.items[e].redeem_time
            ? this.items[e].redeem_time.substr(0, 5)
            : "--"
        );
        theItem.push(
          this.items[e].status == 0 && this.items[e].redeem_date != null
            ? "REDEEMED"
            : this.items[e].status == 1
              ? "CANCELLED CODE"
              : "PENDING"
        );
        theItem.push(
          this.items[e].status == 1 && this.items[e].cancelled_by ? this.items[e].cancelled_by : "--"
        );

        theItem.push(this.items[e].credit_amount);

        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function (r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function (type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>
<style scoped>
button:disabled,
button[disabled] {
  border: 1px solid #d0cdcd;
  background-color: #d0cdcd;
  color: #d0cdcd;
}

button:disabled,
button[disabled] svg {
  color: #d0cdcd;
}

.custom-dialog .v-dialog__content {
  background-color: white;
  /* Set the desired background color for the dialog content area */
}

.custom-dialog .v-dialog__container {
  background-color: transparent;
  /* Set the background color of the backdrop to transparent */
}
</style>
